// A2-581 screen map lead 6 (review of dcefbf25): a country form's link
// "/workflow/review?calc_id=X&card=Y" asks for card Y on calculation X. The
// address is rewritten while X opens (calc_id stripped, then the step route
// replaces the query), so the review page cannot read it from the address:
// it would open Y on whatever calculation is on screen, or never. The request
// is captured once, when the link is followed, and answered only on X.
// Review of cafbb55b: a request never answered (the card is not on X's
// review, or X opened straight on Step 6) lapses rather than firing the next
// time Step 4 shows X.
export const INTENT_TTL_MS = 5 * 60 * 1000;
let intent = null;   // { calcId, card, at }

export const setCardIntent = (calcId, card) => { intent = calcId && card ? { calcId, card, at: Date.now() } : null; };
export const clearCardIntent = () => { intent = null; };
export const cardIntentFor = (calcId) => {
  if (intent && Date.now() - intent.at > INTENT_TTL_MS) intent = null;
  return intent && calcId && intent.calcId === calcId ? intent.card : null;
};
